import React, { useEffect, useState } from 'react';
import { WithStyles } from '@material-ui/core/styles';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { RouteComponentProps, useParams, withRouter } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { withStyles } from '@material-ui/core';
import { Location, selectLocationSettingsInitQuery } from './queries';
import styles from './styles';
import ViewStockComponent from '../../../../components/Global/Stock';
import Dashboard from '../../../../layouts/Dashboard';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

interface UrlParams {
  location_id: string;
}

enum InventoryRestockEnum {
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

const OrgViewLocationStock = ({ classes }: Props): React.ReactElement => {
  const { location_id } = useParams<UrlParams>();

  const [location, setLocation] = useState<Location>({
    name: '',
    inventory_restock_type: '',
  });

  const { data } = useQuery(selectLocationSettingsInitQuery(location_id), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && data) {
      setLocation(data.locations_by_pk);
    }
    return () => {
      mounted = false;
    };
  }, [data]);

  return (
    <Dashboard
      breadcrumbs={[
        { label: 'Locations', link: '/org/locations' },
        { label: location.name, link: `/org/locations/${location_id}` },
        { label: 'Stock Management' },
      ]}>
      <ViewStockComponent classes={{}} location_id={location_id} inventory_restock_type={location.inventory_restock_type as InventoryRestockEnum} />
    </Dashboard>
  );
};

export default withRouter(withStyles(styles)(OrgViewLocationStock));
